import React, { memo } from 'react';
import { isExpanded, isLeaf } from './CheckBoxTreeUtils';
import { NodeItem } from './NodeItem';
import { useCheckBoxTree } from './useCheckBoxTree';
import { CheckBoxTreeProps, Node } from './types';
import { StyledCheckboxTreeContainer } from './StyledCheckboxTreeElements';

/**
 * @deprecated Please use CheckBoxTreeVirtualized
 */
export const CheckBoxTree: React.FC<React.PropsWithChildren<CheckBoxTreeProps>> = ({
  checkChildren,
  rootsCheckChildren = false,
  nodes,
  onCheck,
  onExpand,
  expanded: expandedItems,
  checked: checkedItems,
  style,
  keepExpanded,
  dataTest,
  className
}) => {
  const { checked, expanded, handleChecked, handleExpanded } = useCheckBoxTree(
    expandedItems,
    checkedItems,
    nodes,
    onCheck,
    onExpand,
    rootsCheckChildren ? 'root' : checkChildren ? 'parent' : 'none'
  );

  const renderTree = (node?: Node) => {
    if (!node) {
      return null;
    }
    const leaf = isLeaf(node);
    const expand = isExpanded(node, keepExpanded, expanded);

    const toggleChecked = () => {
      handleChecked(node);
    };

    const toggleExpanded = () => {
      handleExpanded(node);
    };

    return (
      <NodeItem
        node={node}
        keepExpanded={keepExpanded}
        expand={expand}
        checked={checked}
        onExpand={toggleExpanded}
        onCheck={toggleChecked}
        key={node.value}
      >
        {leaf && expand && <div className="children-wrapper">{node.children?.map((node) => renderTree(node))}</div>}
      </NodeItem>
    );
  };

  return (
    <StyledCheckboxTreeContainer className={className} data-test={dataTest ?? 'checkbox-tree'} style={style}>
      {nodes.map(renderTree)}
    </StyledCheckboxTreeContainer>
  );
};

export default memo(CheckBoxTree);
